import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dialog, FlatButton, IconButton, IconMenu, MenuItem } from 'material-ui';
import { Link } from 'react-router-dom';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { grey400 } from 'material-ui/styles/colors';
import AdminService, { ADMIN } from '../../services/admin';
import style from '../../styles/styles';
import styles from './PagePage.css';
import {
    EDIT_PAGE_MEDIA_PAGE,
    EDIT_PAGE_PAGE,
    PAGE_MIME_MEDIA_LIST_PAGE,
    PAGE_LIST_PAGE,
} from '../../constants/routes';
import Loading from '../../components/common/Loading/Loading';
import { deletePage, postPageMedia, getPage, fetchPage } from '../../store/pages/actions';
import { deleteComment } from '../../store/comments/actions';
import { fetchApp } from '../../store/apps/actions';
import withTranslation from '../../hoc/withTranslation';
import PageInfo from '../../components/page/PageInfo';
import MediaBlocs from '../../components/media/MediaBlocs/MediaBlocs';
import CommentList from '../../components/comment/CommentList/CommentList';
import Error from '../../components/common/Error/Error';
import ModuleService from '../../services/module';
import CommentService from '../../services/comment';

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400} />
    </IconButton>
);

export class PagePage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        page: PropTypes.object,
    };

    static defaultProps = {};

    state = {
        openRemovePage: false,
        commentToDelete: null,
        openDeleteComment: false,
    };

    componentWillMount() {
        this.fetch();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match || this.props.currentLang !== nextProps.currentLang) {
            this.fetch(nextProps.match.params.appId,
                nextProps.match.params.pageId,
                nextProps.currentLang,
            );
        }
        if (this.props.sending && !nextProps.sending) {
            if (!nextProps.page) {
                this.props.history.push(PAGE_LIST_PAGE.replace(':appId', this.props.app.id));
            }
        }
        if (this.props.commentSending && !nextProps.commentSending) {
            this.handleCloseDeleteComment();
            this.getPage();
        }
    }

    handleOpenPage = () => {
        this.setState({ openRemovePage: true });
    };

    handleClosePage = () => {
        this.setState({ openRemovePage: false });
    };

    deleteOnePage = () => {
        this.props.deletePage(this.props.app.id, this.props.page.id, this.props.currentLang);
    };

    selectMime = (mime) => {
        let url = PAGE_MIME_MEDIA_LIST_PAGE
            .replace(':appId', this.props.app.id)
            .replace(':pageId', this.props.page.id)
            .replace(':shortMime', mime);
        this.props.history.push(url);
    };

    editMedia = (mediaId) => {
        let url = EDIT_PAGE_MEDIA_PAGE
            .replace(':appId', this.props.app.id)
            .replace(':pageId', this.props.page.id)
            .replace(':mediaId', mediaId);
        this.props.history.push(url);
    };

    // Delete comment

    handleDeleteComment = (comment) => {
        this.setState({
            openDeleteComment: true,
            commentToDelete: comment,
        });
    };

    handleCloseDeleteComment = () => {
        this.setState({
            openDeleteComment: false,
            commentToDelete: null,
        });
    };

    deleteComment = () => {
        this.props.deleteComment(this.props.app.id, this.state.commentToDelete.id);
    };

    // Fetch

    fetch(appId = null, pageId = null, lang = null) {
        this.fetchApplication(appId);
        this.fetchPage(appId, pageId, lang);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    fetchPage(appId = null, pageId = null, fetchLang = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const page = pageId || this.props.match.params.pageId;
            const lang = fetchLang || this.props.currentLang;

            if (app && page) {
                this.props.fetchPage(app, page, lang);
            }
        }
    }

    getPage(appId = null, pageId = null, fetchLang = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const page = pageId || this.props.match.params.pageId;
            const lang = fetchLang || this.props.currentLang;

            if (app && page) {
                this.props.getPage(app, page, lang);
            }
        }
    }

    renderMenu() {
        let menu;

        if (AdminService.isAuthorized(ADMIN, this.props.user)) {
            menu = (
                <IconMenu
                    style={styles.buttons}
                    iconButtonElement={iconButtonElement}
                    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                    targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                >
                    <Link
                        to={EDIT_PAGE_PAGE.replace(':appId', this.props.app.id).replace(':pageId',
                            this.props.page.id,
                        )}>
                        <MenuItem>
                            {this.props.t('generic.edit')}
                        </MenuItem>
                    </Link>
                    <MenuItem onClick={this.handleOpenPage}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                </IconMenu>
            );
        }
        return menu;
    };

    renderDeleteCommentDialog(comment) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.commentSending}
                onClick={this.handleCloseDeleteComment}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.commentSending}
                onClick={this.deleteComment}
            />,
        ];
        const text = CommentService.getTextForComment(
            this.props.t,
            comment,
            'module.comment.delete_comment_confirmation'
        );
        return (
            <Dialog actions={actions}
                    title={this.props.t('module.comment.reject_comment')}
                    modal={this.props.commentSending}
                    open={this.state.openDeleteComment}
                    onRequestClose={this.handleCloseDeleteComment}>
                {this.props.commentSending && <Loading paper={false} />}
                {!this.props.commentSending &&
                <p>
                    <div dangerouslySetInnerHTML={{ __html: text }} />
                </p>
                }
            </Dialog>
        );
    }

    renderDeletePageDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleClosePage}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteOnePage}
            />,
        ];

        return (
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.openRemovePage}
                onRequestClose={this.handleClosePage}
            >
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                <p>{this.props.t('module.page.delete_page_confirmation')}</p>
                }
            </Dialog>
        );
    }

    renderInformation() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <PageInfo
                    app={this.props.app}
                    lang={this.props.currentLang}
                    page={this.props.page}
                />
            </div>
        );
    }

    renderMedias() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <MediaBlocs
                    app={this.props.app}
                    entity={this.props.page}
                    medias={this.props.page.medias || []}
                    pendingMedias={this.props.pendingMedias}
                    postMedia={this.props.postPageMedia}
                    selectMime={this.selectMime}
                    uploadedMedias={this.props.uploadedMedias}
                    failedMedias={this.props.failedMedias}
                    currentLang={this.props.currentLang}
                />
            </div>
        );
    }

    renderComment() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <CommentList
                    title={this.props.t('generic.comments')}
                    user={this.props.user}
                    comments={this.props.page.comments}
                    handleDeleteComment={this.handleDeleteComment}
                />
            </div>

        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.page) {
            return <Loading paper={false} />;
        } else {
            return (
                <div style={styles.container}>
                    {this.renderMenu()}
                    {this.renderDeletePageDialog()}
                    {this.state.commentToDelete && this.renderDeleteCommentDialog(this.state.commentToDelete)}

                    <h3 style={style.navigation}>{this.props.t('module.page.name')} / {this.props.t(
                        'generic.detail')} - {this.props.page.title}</h3>
                    <div className="row">
                        {this.renderInformation()}
                        {this.renderMedias()}
                        {ModuleService.hasModule(this.props.app,
                            ModuleService.COMMENTS,
                        ) && this.renderComment()}
                    </div>

                </div>
            );
        }
    }

}

function mapStateToProps(state, ownProps) {
    return {
        error: state.apps.error || state.pages.error,
        user: state.auth.content,
        loading: state.apps.pending || state.pages.pending,
        sending: state.pages.sending,
        page: state.pages.currentPage,
        currentLang: state.ui.currentLang,
        app: state.apps.currentApplication,
        pendingMedias: state.pages.pendingMedias,
        uploadedMedias: state.pages.uploadedMedias,
        failedMedias: state.pages.failedMedias,
        currentMedia: state.pages.currentMedia,
        commentSending: state.comments.sending,
    };
}

export default connect(mapStateToProps, {
    deletePage,
    postPageMedia,
    getPage,
    fetchPage,
    deleteComment,
    fetchApp,
})(withTranslation(PagePage));




// WEBPACK FOOTER //
// src/containers/page/PagePage.js